export enum EngagementUserIdTypeEnum {
  PHONE_NUMBER = 'phoneNumber',
  USER_KEY = 'userKey',
  APP_USER_ID = 'appUserId',
}
